import React from "react";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import createPalette from "@mui/material/styles/createPalette";
import { useField } from "formik";

declare module "@mui/material/styles" {
  interface Theme {}
  // allow configuration using `createTheme`
  interface ThemeOptions {}
}

const customPalette: any = createPalette({
  primary: {
    main: "#1D183E",
    "100": "#ECF0FC",
  },
  warning: {
    main: "#EAA800",
    "100": "#FBF1D6",
  },
  success: {
    main: "#00A689",
    "100": "#E4F7F3",
  },
});

const theme = createTheme({
  components: {},
});

interface ICheckbox {
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  label?: string;
  checked?: boolean;
  helperText?: string;
  heading?: string;
}

export const CheckBox = ({
  name,
  onChange,
  disabled,
  label,
  helperText,
  heading,
}: ICheckbox) => {
  const [field, meta, helpers] = useField({ name, type: "checkbox" });

  const onInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    onChange?.(e);
    helpers.setValue(checked);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <FormControl required error={!!meta.error} variant="standard">
          {heading && <FormLabel component="legend">Pick two</FormLabel>}
          <FormGroup>
            <FormControlLabel
              {...field}
              disabled={disabled}
              control={
                <Checkbox
                  checked={field.checked}
                  value={field.value}
                  onChange={onInputChange}
                />
              }
              label={label}
            />
          </FormGroup>
          <FormHelperText>{meta.error || helperText}</FormHelperText>
        </FormControl>
      </Box>
    </ThemeProvider>
  );
};
